import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard, movie, film"><path d="M21 20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V9.5H21V20.25Z" fill="currentColor"/><path d="M7.20898 8H3V3.75C3 3.33579 3.33579 3 3.75 3H8.87598L7.20898 8Z" fill="currentColor"/><path d="M13.459 8H8.79102L10.458 3H15.126L13.459 8Z" fill="currentColor"/><path d="M20.25 3C20.6642 3 21 3.33579 21 3.75V8H15.041L16.708 3H20.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClapboard;
